import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=be763ec0&scoped=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=be763ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be763ec0",
  null
  
)

export default component.exports